
import Vue from "vue";
export default Vue.extend({
  name: "compoent-area-view-header",
  props: {
    backBtnTitle: {
      type: String,
      default: "",
    },
    backBtn: Boolean,
    showTitle: String,
    active: Boolean,
  },

  computed: {
    hideCloseBtn(): boolean {
      if (this.$route.path.includes("/top")) {
        return true;
      }
      return false;
    },
  },

  updated() {
    setTimeout(() => {
      (this.$refs["active-close-btn"] as Vue & HTMLElement)?.focus();
    }, 350); // to wait anime finished
  },

  methods: {
    backBtnClicked() {
      this.$emit("back-btn-clicked");
    },
    closeAreaView() {
      this.$emit("close-btn-clicked");
    },
  },
});
